import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
// import { userColumns, userRows } from "../../studentDataSource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const Datatable = () => {
  const [data, setData] = useState([]);

  const fetchData = () => {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ "Access-Control-Allow-Origin": "*" }),
    };
    fetch(
      "https://api.spohrm.org/services/getstudent",
      requestOptions
    )
      .then((res) => res.json())
      .then(
        (result) => {
          const newData = result.data.map((l) =>
            l._id ? { ...l, id: l._id } : null
          );
          setData(newData);
          // console.log(newData);
        },

        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    fetchData();
    data.map((data) => console.log(data.school_name));
  }, []);

  // -------------------------------------column -------------------------------
  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "first_name",
      headerName: "Name",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
          
            {params.row.first_name}
          </div>
        );
      },
    },
    {
      field: "schoolName",
      headerName: "School Name",
      width: 230,
    },
    {
      field: "student_class",
      headerName: "Class",
      width: 100,
    },
    {
      field: "section",
      headerName: "section",
      width: 160,
      renderCell: (params) => {
        return (
          <div className={`cellWithStatus ${params.row.section}`}>
            {params.row.section}
          </div>
        );
      },
    },
  ];
  
  // -------------------------------------column -------------------------------

  const handleDelete = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link to="/home/studentList/student"  state={{
              id: params.row.id,
                first_name: params.row.first_name,
                schoolName: params.row.schoolName,
                student_class: params.row.student_class,
                section: params.row.section,
              }}
               style={{ textDecoration: "none" }}>
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        Students
        {/* <Link to="/users/new" className="link">
          Add New
        </Link> */}
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        getRowId={data.id}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
